import * as React from 'react';
import c from 'classnames';
const StatusMessage = props => {
  const {
    type,
    children
  } = props;
  const classNames = c('StatusMessage', {
    ["StatusMessage--".concat(type)]: type
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classNames
  }, children);
};
export default StatusMessage;